import LanguageSelector from '@uturn/portal/components/language-selector';
import { ModeToggle } from '@uturn/ui-kit';
import { UserNav } from './user-nav';

/**
 * Header utilities group: Mode toggle, Language selector, and User navigation
 */
export const HeaderUtilities = ({
	showModeToggle = true,
	showLanguageSelector = true,
	dropdownItems,
	user,
	onLogout,
}: {
	showModeToggle?: boolean;
	showLanguageSelector?: boolean;
	dropdownItems?: { name: string; href: string }[];
	user: { name: string; role: string };
	onLogout?: () => void | Promise<void>;
}) => {
	return (
		<div className="ml-auto flex items-center gap-4 md:gap-1 lg:gap-4">
			{showModeToggle && (
				<div className="hidden md:block">
					<ModeToggle />
				</div>
			)}
			{showLanguageSelector && (
				<div className="hidden md:block">
					<LanguageSelector />
				</div>
			)}
			<UserNav dropdownItems={dropdownItems} user={user} onLogout={onLogout} />
		</div>
	);
};
